// This is StockComparisonContext.js in src/conexts
import React, { createContext, useState, useEffect } from 'react';


export const StockComparisonContext = createContext();

export function StockComparisonProvider({ children }) {

   // Initialize state from localStorage or use defaults
   const [selectedSymbols, setSelectedSymbols] = useState(() => {
     const saved = localStorage.getItem('selectedSymbols');
     return saved ? JSON.parse(saved) : ["AAPL"];
   });
   
   const [activeFilters, setActiveFilters] = useState(() => {
     const saved = localStorage.getItem('activeFilters');
     return saved ? JSON.parse(saved) : [];
   });
   
   const [selectedMetric, setSelectedMetric] = useState(() => {
    const saved = localStorage.getItem('selectedMetric');
    return saved || "priceEarningsRatio"; // ← changed from "vwap"
  });


     // ▶ In-memory caches to avoid re-fetching on every navigation
  const [metricsCache, setMetricsCache] = useState({});
  const [chartCache, setChartCache] = useState({});

  
   // Save to localStorage whenever state changes
   useEffect(() => {
     localStorage.setItem('selectedSymbols', JSON.stringify(selectedSymbols));
   }, [selectedSymbols]);
   
   useEffect(() => {
     localStorage.setItem('activeFilters', JSON.stringify(activeFilters));
   }, [activeFilters]);
   
   useEffect(() => {
     localStorage.setItem('selectedMetric', selectedMetric);
   }, [selectedMetric]);


  // Function to set stocks from watchlist
 const setStocksFromWatchlist = (stocks) => {
   // Limit to 5 stocks (StockComparison UI limit)
   setSelectedSymbols(stocks.slice(0, 5));
 };


  return (
    <StockComparisonContext.Provider
      value={{
        selectedSymbols, setSelectedSymbols,
        activeFilters, setActiveFilters,
        selectedMetric, setSelectedMetric, 
        setStocksFromWatchlist,
        // ▶ expose caches so pages can reuse data
      metricsCache, setMetricsCache,
      chartCache, setChartCache,
      }}
    >
      {children}
    </StockComparisonContext.Provider>
  );
}